<div>
  <div>
    <png-display-error errorType="signedOut"></png-display-error>
    <div
      class="card mt-5"
      style="display: var(--storybook-secondary-bg-ex-display)"
    >
      <div class="card-header">Secondary Background</div>
      <div class="card-body">
        <p>
          Set the
          <em>styleClass</em>
          attribute of the parent element to
          <em>white-bg&nbsp;&nbsp;</em>
          when parent has a white background:
        </p>
        <div class="white-bg">
          <png-display-error errorType="signedOut"></png-display-error>
        </div>
      </div>
    </div>
  </div>
  <div class="centered-content">
    <button (click)="signIn()" class="btn btn-link">Sign In Again</button>
  </div>
</div>
